import { useQuery } from '@tanstack/react-query';
import type { OrderDetail } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const orderQueryKey = (orderId: string) => ['admin', 'order', orderId] as const;

export const useOrderQuery = (orderId: string | undefined) =>
  useQuery<OrderDetail>({
    queryKey: orderQueryKey(orderId ?? ''),
    enabled: Boolean(orderId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/orders/{orderId}',
        {
          params: { path: { orderId: orderId as string } },
        },
      );
      return data as OrderDetail;
    },
  });
